(function () {
  'use strict';

  function initJakCountrySelector() {
    var triggers = document.querySelectorAll('[data-jak-country-trigger]');
    var drawer = document.getElementById('jak-country-drawer');
    var overlay = document.querySelector('.js-go-cart-overlay');
    var cartDrawer = document.querySelector('.js-go-cart-drawer');
    var input = document.querySelector('[data-jak-country-input]');
    var form = input ? (input.form || input.closest('form')) : null;
    var searchInput = document.querySelector('.js-jak-country-search');
    var emptyState = document.querySelector('.js-jak-country-empty');
    var closeButtons = document.querySelectorAll('.js-jak-country-close');
    var items = document.querySelectorAll('#jak-country-drawer [data-country-item]');
    var options = document.querySelectorAll('#jak-country-drawer .jak-country-drawer__option');

    if (!triggers.length || !drawer || !overlay || !input || !form) {
      return;
    }

    var isOpen = false;
    var activeTrigger = null;

    function isCartOpen() {
      return cartDrawer && cartDrawer.classList.contains('is-open');
    }

    function showOverlay() {
      overlay.classList.add('is-open');
    }

    function hideOverlayIfIdle() {
      if (!isCartOpen() && !isOpen) {
        overlay.classList.remove('is-open');
      }
    }

    function openPanel(trigger) {
      if (isOpen) return;

      isOpen = true;
      activeTrigger = trigger;
      showOverlay();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('overflowy');
      document.body.classList.add('overflowy');
      document.addEventListener('pointerdown', onPointerDown, true);
      document.addEventListener('keydown', onKeyDown, true);

      if (searchInput) {
        searchInput.value = '';
        filterCountries('');
        window.requestAnimationFrame(function () {
          searchInput.focus();
        });
      }
    }

    function closePanel() {
      if (!isOpen) return;

      isOpen = false;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.removeEventListener('pointerdown', onPointerDown, true);
      document.removeEventListener('keydown', onKeyDown, true);

      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });

      if (!isCartOpen()) {
        overlay.classList.remove('is-open');
        document.documentElement.classList.remove('overflowy');
        document.body.classList.remove('overflowy');
      }

      if (activeTrigger) {
        activeTrigger.focus();
      }

      activeTrigger = null;
    }

    function onPointerDown(event) {
      if (!isOpen) return;

      var target = event.target;
      if (drawer.contains(target)) return;
      if (target.closest('[data-jak-country-trigger]')) return;

      closePanel();
    }

    function onKeyDown(event) {
      if (!isOpen) return;
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closePanel();
    }

    function filterCountries(query) {
      var visibleCount = 0;

      items.forEach(function (item) {
        var countryName = item.dataset.countryName || '';
        var isMatch = !query || countryName.indexOf(query) !== -1;
        item.classList.toggle('is-hidden', !isMatch);
        if (isMatch) visibleCount += 1;
      });

      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openPanel(trigger);
      });
    });

    overlay.addEventListener('click', function () {
      if (isOpen) {
        closePanel();
      }
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closePanel();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function (event) {
        filterCountries(event.target.value.trim().toLowerCase());
      });
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var value = option.dataset.value;
        if (!value || value === input.value) {
          closePanel();
          return;
        }

        input.value = value;
        form.submit();
      });
    });

    window.jakCountrySelector = {
      open: openPanel,
      close: closePanel,
      hideOverlayIfIdle: hideOverlayIfIdle
    };
  }

  initJakCountrySelector();
})();
